export default __webpack_public_path__ + "static/media/wildclaw.beb13f44.png";